<template>
  <div>
    <d-field label="Filemaker Contact ID" message="Leave empty to create a new record, or add an ID to update the record">
      <d-input v-model="computedContact.filemakerContactId" />
    </d-field>
    <d-field label="Filemaker Organization ID">
      <d-input v-model="computedContact.filemakerOrganizationId" />
    </d-field>
    <d-field label="First Name">
      <d-input v-model="computedContact.firstName" />
    </d-field>
    <d-field label="Last Name">
      <d-input v-model="computedContact.lastName" />
    </d-field>
    <d-field label="Job Title">
      <d-input v-model="computedContact.jobTitle" />
    </d-field>
    <d-field label="Organization Name">
      <d-input v-model="computedContact.organizationName" />
    </d-field>
    <d-field label="Member Type">
      <d-input v-model="computedContact.memberType" />
    </d-field>
    <d-field label="Email">
      <d-input v-model="computedContact.email" />
    </d-field>
    <d-field label="Phone #">
      <d-input v-model="computedContact.phone" />
    </d-field>
    <d-field label="Fax #">
      <d-input v-model="computedContact.fax" />
    </d-field>
  </div>
</template>

<script>
  export default {
    props: {
      contact: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      computedContact: {
        get() {
          return this.contact;
        },
        set(value) {
          this.$emit('update:contact', value);
        },
      },
    },
  };
</script>